export const GET_PARENT_PETITIONS_REQUEST = 'GET_PARENT_PETITIONS_REQUEST';
export const GET_PARENT_PETITIONS_SUCCESS = 'GET_PARENT_PETITIONS_SUCCESS';
export const GET_PARENT_PETITIONS_FAILED = 'GET_PARENT_PETITIONS_FAILED';

export const SET_PARENT_PETITION_ID = 'SET_PARENT_PETITION_ID';
